module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "demo-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.getDemoEvent
    }
  }, [_vm._v("Get a demo")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d089575c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/MikMakAttach/components/GetDemoButton.vue
// module id = 499
// module chunks = 0